import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=228115a1&"
import script from "./privacy.vue?vue&type=script&lang=js&"
export * from "./privacy.vue?vue&type=script&lang=js&"
import style0 from "./privacy.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228115a1')) {
      api.createRecord('228115a1', component.options)
    } else {
      api.reload('228115a1', component.options)
    }
    module.hot.accept("./privacy.vue?vue&type=template&id=228115a1&", function () {
      api.rerender('228115a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/privacy/privacy.vue"
export default component.exports